import { useEffect, useState } from 'react';

const ROUTE_EVENT = 'llm-context:navigate';

function getBasePath(): string {
  const baseUrl = import.meta.env.BASE_URL ?? '/';
  return baseUrl.endsWith('/') && baseUrl.length > 1 ? baseUrl.slice(0, -1) : baseUrl;
}

export function withBasePath(pathname: string): string {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const basePath = getBasePath();

  if (!basePath || basePath === '/') {
    return normalizedPath;
  }

  return `${basePath}${normalizedPath}`;
}

export function stripBasePath(pathname: string): string {
  const basePath = getBasePath();

  if (basePath && basePath !== '/' && pathname.startsWith(basePath)) {
    const stripped = pathname.slice(basePath.length);
    return stripped || '/';
  }

  return pathname || '/';
}

export function navigateTo(pathname: string): void {
  const target = withBasePath(pathname);
  window.history.pushState({}, '', target);
  window.dispatchEvent(new Event(ROUTE_EVENT));
}

export function useAppPathname(): string {
  const [pathname, setPathname] = useState(() => stripBasePath(window.location.pathname));

  useEffect(() => {
    const update = () => setPathname(stripBasePath(window.location.pathname));

    window.addEventListener('popstate', update);
    window.addEventListener(ROUTE_EVENT, update);

    return () => {
      window.removeEventListener('popstate', update);
      window.removeEventListener(ROUTE_EVENT, update);
    };
  }, []);

  return pathname;
}
